module.exports = __webpack_public_path__ + "static/media/iconHn.a4189ebe.svg";